// MP3 player
$(document).ready(function(){
  if ($('#password').offset()) {
    checkStrength();
  }
  // Timezone
  var tz = jstz.determine();
  $('.timezone_field').val( tz.name() );

  $(".select2-form-control-funnel").select2()

  // FLASH ALERT FADE
  $('#main_flash_alert').delay(7000).fadeOut(2000);
  if ($("#svgContainer").offset()) {
    $("#svg1").attr("height", "0");
    $("#svg1").attr("width", "0");
    $("#svg2").attr("height", "0")
    $("#svg2").attr("width", "0");
    $('.hidden_label').text('');

    connectAll();
    resizeBgFunnel();
  }

  onclick_play_mp3();
});

function drawPath(svg, path, startX, startY, endX, endY) {
    // get the path's stroke width (if one wanted to be  really precize, one could use half the stroke size)
    var stroke =  parseFloat(path.attr("stroke-width"));

    path.attr("d",  "M"  + startX + " " + startY +
                    " L"  + endX + " " + endY );
}
function drawArrow(svg, path, startX, startY) {
  var stroke =  parseFloat(path.attr("stroke-width"));

  path.attr("d",  "M"  + (startX-5) + " " + (startY+7) +
                  " L" + (startX+5) + " " + startY +
                  " L" + (startX-5) + " " + (startY-7) );
}

function connectElements(svg, svgarrow, path, patharrow, startElem, endElem) {
    var svgContainer= $("#svgContainer");

    // get (top, left) corner coordinates of the svg container
    var svgTop  = svgContainer.offset().top;
    var svgLeft = svgContainer.offset().left;

    // get (top, left) coordinates for the two elements
    var startCoord = startElem.offset();
    var endCoord   = endElem.offset();

    // calculate path's start (x,y)  coords
    // we want the x coordinate to visually result in the element's mid point
    var startX = startCoord.left + startElem.outerWidth();    // x = left offset + 0.5*width - svg's left offset
    var startY = startCoord.top  + 0.5*startElem.outerHeight() - svgTop;        // y = top offset + height - svg's top offset

        // calculate path's end (x,y) coords
    var endX = endCoord.left;
    var endY = endCoord.top + 0.5*endElem.outerHeight() - svgTop;

    var startXarrow = ((startX + endX)/2)
    var startYarrow = startY

    // call function for drawing the path
    drawPath(svg, path, startX, startY, endX, endY);
    drawArrow(svgarrow, patharrow, startXarrow, startYarrow);
}



function connectAll() {
    // connect all the paths you want!
    connectElements($("#svg1"), $("#svgarrow1"), $("#path1"), $("#patharrow1"), $("#step1"), $("#step2"));
    connectElements($("#svg2"), $("#svgarrow2"), $("#path2"), $("#patharrow2"), $("#step2"), $("#step3"));
}

function resizeBgFunnel() {
  // Used in the sign up funnel
  var windowHeight = $(window).height();
  var headerHeight = $(".header-funnel").innerHeight();
  var footerHeight = $(".footer-funnel").height();
  var newHeight = windowHeight - headerHeight - footerHeight;
  $(".left-col-funnel").innerHeight(Math.max(newHeight, $(".left-col-funnel").innerHeight()));
  $(".bg-funnel").innerHeight(Math.max(newHeight, $(".left-col-funnel").innerHeight()));
  if($(window).width() > 990) {



    // But then if the text on right column is hidden by the image, add the difference
    var imageYStart = $('.bottom-right-image-funnel').offset().top;
    var textFunnel = $('#preview-following-end').offset().top + $('#preview-following-end').outerHeight();
    if(imageYStart - textFunnel < 0) {
      $(".bg-funnel").innerHeight($(".bg-funnel").innerHeight() - imageYStart + textFunnel);
      $(".left-col-funnel").innerHeight($(".left-col-funnel").innerHeight() - imageYStart + textFunnel);
    }
  }
  if($('#special-row-step1').offset()) {
    var specialRowStep1YEnd = $('#special-row-step1').offset().top + $('#special-row-step1').outerHeight();
    var submitContainerStep1YStart = $('.submit-container-step1').offset().top;
    if(submitContainerStep1YStart - specialRowStep1YEnd < 0) {
      $(".left-col-funnel").innerHeight($(".left-col-funnel").innerHeight() - submitContainerStep1YStart + specialRowStep1YEnd);
      $(".bg-funnel").innerHeight($(".left-col-funnel").innerHeight());
    }
  }
  if($('.blue-container-funnel').offset()) {
    var specialRowStep1YEnd = $('.blue-container-funnel').offset().top + $('.blue-container-funnel').outerHeight();
    var submitContainerStep1YStart = $('.submit-container-new').offset().top;
    if(submitContainerStep1YStart - specialRowStep1YEnd < 0) {
      $(".left-col-funnel").innerHeight($(".left-col-funnel").innerHeight() - submitContainerStep1YStart + specialRowStep1YEnd);
      $(".bg-funnel").innerHeight($(".left-col-funnel").innerHeight());
    }
  }
}

$(window).resize(function () {
  // reset svg each time
  if ($("#svgContainer").offset()) {
    $("#svg1").attr("height", "0");
    $("#svg1").attr("width", "0");
    $("#svg2").attr("height", "0");
    $("#svg2").attr("width", "0");
    $('.hidden_label').text('');
    connectAll();
    resizeBgFunnel();
  }
});

function checkStrength() {
  var strength = {
  0: {width: "25%", color: "#f0a3a3", grad: "linear-gradient(to bottom, #f0a3a3, #f42323)", text: "Weak"},
  1: {width: "25%", color: "#f0a3a3", grad: "linear-gradient(to bottom, #f0a3a3, #f42323)", text: "Weak"},
  2: {width: "50%", color: "#f1a165", grad: "linear-gradient(to bottom, #f1a165, #f36d0a)", text: "Fair"},
  3: {width: "75%", color: "rgb(43,194,83)", grad: "linear-gradient(to bottom, rgb(84,240,84), rgb(43,194,83))", text: "Good"},
  4: {width: "100%", color: "rgb(43,194,83)", grad: "linear-gradient(to bottom, rgb(84,240,84), rgb(43,194,83))", text: "Strong"}
}
  var password = document.getElementById('password');
  var meter = $(".meter");
  var passwordStrength = $("#password_strength");
  var text = $(".meter-text");
  function callChecker() {
    var val = password.value;
    var result = zxcvbn(val);
    // Update the text indicator
    if (val !== "") {
      passwordStrength.width(strength[result.score].width);
      passwordStrength.css("background-color", strength[result.score].color);
      passwordStrength.css("background-image", strength[result.score].grad);
      text.text(strength[result.score].text);
      text.css("color", strength[result.score].color);
    } else {
      passwordStrength.width(strength[0].width);
      passwordStrength.css("background-color", strength[0].color);
      passwordStrength.css("background-image", strength[0].grad);
      text.text(strength[0].text);
      text.css("color", strength[0].color);
    }
  }
  callChecker();
  password.addEventListener('input', function() {
    callChecker();
  });
}



// word count
$.fn.update_count = function() {
  w = wordCount( this.val() );
  $('#words_count').text(w.words);
  $('#minutes_count').text(w.minutes);
}

function onclick_play_mp3(){
  // MP3 PLAYER
  var yourAudio = document.getElementById('mp3_player')//, ctrl = document.getElementById('.mp3_player_control');
  var currenty_playing = false;

  $('.mp3_player_control').click(function() {
    if($( this ).children('.glyphicon').hasClass('glyphicon-play') ) {
      attr = $( this ).attr('data-audio');

      if (typeof attr !== typeof undefined && attr !== false) {
        $('#mp3_player').children('source').attr('src', attr);
        $('#mp3_player').load();
      }

      $( this ).children('.glyphicon').attr('class', "glyphicon glyphicon-pause");
      yourAudio["play"]();
      currenty_playing = true;
    } else if ( $( this ).children('.glyphicon').hasClass('glyphicon-pause') ){
      $( this ).children('.glyphicon').attr('class', "glyphicon glyphicon-play");
      yourAudio["pause"]();
      currenty_playing = false;
    } else{
      attr = $( this ).attr('data-audio');

      if (typeof attr !== typeof undefined && attr !== false) {
        $('#mp3_player').children('source').attr('src', attr);
        $('#mp3_player').load();
      }

      if(currenty_playing){
        yourAudio["pause"]();
        currenty_playing = false;
      } else {
        yourAudio["play"]();
        currenty_playing = true;
      }
    }
    return false;
  });

  $('#mp3_player').on('ended', function() {
    $('.mp3_player_control').children('.glyphicon').attr('class', "glyphicon glyphicon-play");
    yourAudio["pause"]();
  });

  $('#mp3_player').on('timeupdate', function() {
      $('#progression').attr("style", "width: "+(this.currentTime*100 / this.duration)+"%");
  });
}

function wordCount( val ){
  var wom = val.match(/\S+/g);
  return {
    charactersNoSpaces : val.replace(/\s+/g, '').length,
    characters         : val.length,
    words              : wom ? wom.length : 0,
    minutes            : wom ? Math.ceil(wom.length/150) : 0,
    lines              : val.split(/\r*\n/).length
  };
}

/*
 * Bootstrap Cookie Alert by Wruczek
 * https://github.com/Wruczek/Bootstrap-Cookie-Alert
 * Released under MIT license
 */
(function () {
    "use strict";

    var cookieAlert = document.querySelector(".cookiealert");
    var acceptCookies = document.querySelector(".acceptcookies");

    if (!cookieAlert) {
       return;
    }

    cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

    // Show the alert if we cant find the "acceptCookies" cookie
    if (!getCookie("acceptCookies")) {
        cookieAlert.classList.add("show");
    }

    // When clicking on the agree button, create a 1 year
    // cookie to remember user's choice and close the banner
    acceptCookies.addEventListener("click", function () {
        setCookie("acceptCookies", true, 365);
        cookieAlert.classList.remove("show");

        // dispatch the accept event
        window.dispatchEvent(new Event("cookieAlertAccept"))
    });

    // Cookie functions from w3schools
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
})();
